(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    


(function () {

  function initTalonArticle() {


    var articleBody =
      document.getElementById('TalonArticleBody');


    var toc =
      document.getElementById('TalonArticleToc');


    var tocList =
      document.getElementById('TalonArticleTocList');


    var articleLayout =
      document.getElementById('TalonArticleLayout');


    var tocToggle =
      document.getElementById('TalonTocToggle');


    if (
      !articleBody ||
      !toc ||
      !tocList ||
      !articleLayout
    ) {
      return;
    }



    /*
      Prevent duplicate initialization
    */

    if (
      articleBody.dataset.tocInitialized === 'true'
    ) {
      return;
    }


    articleBody.dataset.tocInitialized = 'true';



    /*
      Wrap article tables for clean mobile horizontal scrolling
    */

    var articleTables =
      articleBody.querySelectorAll('table');

    articleTables.forEach(function (table) {

      if (
        table.parentElement &&
        table.parentElement.classList.contains('talon-table-scroll')
      ) {
        return;
      }

      var wrapper =
        document.createElement('div');

      wrapper.className = 'talon-table-scroll';

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);

    });



    /*
      Only H2
    */

    var headings =
      Array.prototype.slice.call(
        articleBody.querySelectorAll('h2')
      );



    /*
      No H2 = hide Contents
    */

    if (headings.length === 0) {

      toc.style.display = 'none';

      articleLayout.classList.add(
        'talon-article-layout--no-toc'
      );

      return;
    }



    /*
      Create safe slug
    */

    function createSlug(text) {

      return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

    }



    var usedIds = {};



    headings.forEach(
      function (heading, index) {


        var headingText =
          heading.textContent.trim();


        /*
          Keep existing H2 ID
        */

        var finalId =
          heading.getAttribute('id');


        if (finalId) {

          usedIds[finalId] = true;

        } else {


          var baseId =
            createSlug(headingText);


          if (!baseId) {

            baseId =
              'section-' + (index + 1);

          }


          finalId = baseId;


          var duplicateNumber = 2;


          while (
            usedIds[finalId] ||
            document.getElementById(finalId)
          ) {

            finalId =
              baseId +
              '-' +
              duplicateNumber;


            duplicateNumber++;

          }


          heading.id = finalId;


          usedIds[finalId] = true;

        }



        /*
          Create TOC link
        */

        var link =
          document.createElement('a');


        link.href =
          '#' + finalId;


        link.textContent =
          headingText;


        link.setAttribute(
          'data-toc-target',
          finalId
        );


        tocList.appendChild(link);

      }
    );



    /*
      Mobile open / close
    */

    if (tocToggle) {

      tocToggle.addEventListener(
        'click',
        function () {


          if (
            window.matchMedia(
              '(max-width: 989px)'
            ).matches
          ) {


            var isOpen =
              toc.classList.toggle(
                'is-open'
              );


            tocToggle.setAttribute(
              'aria-expanded',
              isOpen ? 'true' : 'false'
            );

          }

        }
      );

    }



    /*
      TOC click
    */

    var tocLinks =
      tocList.querySelectorAll('a');


    tocLinks.forEach(
      function (link) {


        link.addEventListener(
          'click',
          function (event) {


            var targetId =
              this.getAttribute(
                'data-toc-target'
              );


            var target =
              document.getElementById(
                targetId
              );


            if (!target) {
              return;
            }


            event.preventDefault();


            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });



            history.replaceState(
              null,
              '',
              '#' + targetId
            );



            /*
              Close mobile Contents
            */

            if (
              window.matchMedia(
                '(max-width: 989px)'
              ).matches
            ) {

              toc.classList.remove(
                'is-open'
              );


              if (tocToggle) {

                tocToggle.setAttribute(
                  'aria-expanded',
                  'false'
                );

              }

            }


          }
        );


      }
    );



    /*
      Highlight current section
    */

    if (
      'IntersectionObserver' in window
    ) {


      var observer =
        new IntersectionObserver(

          function (entries) {


            entries.forEach(
              function (entry) {


                if (
                  !entry.isIntersecting
                ) {
                  return;
                }


                tocLinks.forEach(
                  function (link) {

                    link.classList.remove(
                      'is-active'
                    );

                  }
                );


                var activeLink =
                  tocList.querySelector(
                    '[data-toc-target="' +
                    entry.target.id +
                    '"]'
                  );


                if (activeLink) {

                  activeLink.classList.add(
                    'is-active'
                  );

                }


              }
            );


          },

          {
            rootMargin:
              '-120px 0px -65% 0px',

            threshold: 0
          }

        );



      headings.forEach(
        function (heading) {

          observer.observe(
            heading
          );

        }
      );

    }



    /*
      If page opened with #anchor,
      scroll after H2 IDs exist
    */

    if (window.location.hash) {


      var hashId =
        decodeURIComponent(
          window.location.hash.substring(1)
        );


      var hashTarget =
        document.getElementById(
          hashId
        );


      if (hashTarget) {


        setTimeout(
          function () {

            hashTarget.scrollIntoView({
              behavior: 'auto',
              block: 'start'
            });

          },
          50
        );


      }

    }


  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initTalonArticle
    );

  } else {

    initTalonArticle();

  }



  /*
    Shopify Theme Editor refresh
  */

  document.addEventListener(
    'shopify:section:load',
    function () {

      var articleBody =
        document.getElementById(
          'TalonArticleBody'
        );


      if (articleBody) {

        articleBody.dataset.tocInitialized =
          'false';

      }


      var tocList =
        document.getElementById(
          'TalonArticleTocList'
        );


      if (tocList) {

        tocList.innerHTML = '';

      }


      initTalonArticle();

    }
  );


})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riders-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleries = document.querySelectorAll('.riders-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var slider = gallery.querySelector('.riders-gallery__slider');
      var prev = gallery.querySelector('.riders-gallery__arrow--prev');
      var next = gallery.querySelector('.riders-gallery__arrow--next');
      if (!slider || !prev || !next) return;

      function getItemsPerView() {
        if (window.matchMedia('(max-width: 749px)').matches) {
          return 1;
        }
        return 4;
      }

      function getItemWidth() {
        var firstItem = slider.querySelector('.riders-gallery__item');
        if (!firstItem) return 0;
        return firstItem.getBoundingClientRect().width;
      }

      function updateArrowState() {
        var maxScrollLeft = slider.scrollWidth - slider.clientWidth - 1;
        prev.disabled = slider.scrollLeft <= 0;
        next.disabled = slider.scrollLeft >= maxScrollLeft;
      }

      function scrollByDirection(direction) {
        var itemWidth = getItemWidth();
        if (!itemWidth) return;
        var count = getItemsPerView();
        var distance = itemWidth * count * direction;
        slider.scrollBy({
          left: distance,
          behavior: 'smooth'
        });
      }

      prev.addEventListener('click', function () {
        scrollByDirection(-1);
      });

      next.addEventListener('click', function () {
        scrollByDirection(1);
      });

      slider.addEventListener('scroll', function () {
        updateArrowState();
      });

      window.addEventListener('resize', function () {
        updateArrowState();
      });

      updateArrowState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
